import dayjs from 'dayjs'

export default function useDateTimeFormatter() {
    const formatDateTime = (timestamp, format = 'MM/DD/YYYY hh:mm A') => {
        if (timestamp) {
            return dayjs(timestamp).format(format)
        }
    }

    const formatWithOptionalYear = (timestamp) => {
        if (!timestamp) {
            return 'N/A'
        }

        const currentYear = dayjs().year()
        const yearFormat =
            dayjs(timestamp).year() === currentYear ? '' : '/YYYY '

        return dayjs(timestamp).format(`MM/DD${yearFormat} HH:mm`)
    }

    const formatDate = (timestamp, format = 'MM/DD/YYYY') => {
        if (!timestamp) {
            return '-'
        }

        return dayjs(timestamp).format(format)
    }

    return {
        formatDate,
        formatDateTime,
        formatWithOptionalYear,
    }
}
